import {CommentBox, type CommentBoxHandle, type CommentBoxProps} from '@github-ui/comment-box/CommentBox'
import type React from 'react'

import type {RepoSubject} from '@github-ui/comment-box/subject'
import {
  useLayoutBaseRepository,
  useLayoutPullRequestId,
  useLayoutPullRequestNumber,
} from '@github-ui/pull-requests/pull-request-store-selectors'
import type {DiffRange} from '../../types'

export type ConversationCommentBoxHandle = CommentBoxHandle

export type ConversationCommentBoxProps = Omit<CommentBoxProps, 'children' | 'body'> & {
  children?: React.ReactNode
  label: string
  value: string
  ref?: React.Ref<ConversationCommentBoxHandle>
  comparisonRange?: DiffRange
}

export const ConversationCommentBox = ({ref, children, comparisonRange, ...rest}: ConversationCommentBoxProps) => {
  const pullRequestId = useLayoutPullRequestId()
  const pullRequestNumber = useLayoutPullRequestNumber()
  const repository = useLayoutBaseRepository()
  const subject: RepoSubject = {
    type: 'pull_request',
    id: {
      id: pullRequestId.toString(),
    },
    pullRequestNumber,
    repository: {
      databaseId: repository.id,
      nwo: `${repository.ownerLogin}/${repository.name}`,
      slashCommandsEnabled: false, // TODO - follow up on this
    },
    comparison: comparisonRange
      ? {
          startCommitOid: comparisonRange.baseOid,
          endCommitOid: comparisonRange.headOid,
        }
      : undefined,
  }

  return (
    <CommentBox
      {...rest}
      ref={ref}
      placeholder="Leave a comment"
      actions={children}
      subject={subject}
      showLabel={false}
    />
  )
}

ConversationCommentBox.displayName = 'ConversationCommentBox'
